<script setup lang="ts">
  import { useGlobalSearchStore } from '@/store/GlobalSearch'
  import { watch } from 'vue'

  const { mobile } = useDisplay()
  const globalSearchStore = useGlobalSearchStore()

  watch(mobile, (isMobile) => {
    if (isMobile && globalSearchStore.isDropdownSearchActive) {
      globalSearchStore.closeGlobalSearchDropDown()
    }
  })
</script>
<template>
  <header data-event="General Elements" data-section-name="Game GNB" data-section-number="0">
    <div class="header-wrapper">
      <MobileBar v-if="mobile" />
      <DesktopBar v-else />
    </div>
    <GlobalSearchDropdown v-if="!mobile" />
  </header>
</template>

<style lang="scss" scoped>
  header {
    width: 100%;
    font-weight: 400;
    position: sticky;
    top: 0;
    z-index: 20;
    background-color: var(--nav-bg-c);
    color: var(--nav-font-c);
  }

  .header-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: var(--nav-bg-c);
    color: var(--nav-font-c);
    position: relative;
    z-index: 1;
  }
</style>
